// deps
import React from "react";
import Head from "next/head";

// libraries
import { generateUri } from "@cloudspire/legacy-shared/src/libraries";

// contexts
import { useRouters } from "@cloudspire/legacy-resources/src/contexts/routers";
import { useRoute } from "@cloudspire/legacy-resources/src/contexts/route";
import { useConfiguration } from "@cloudspire/legacy-resources/src/contexts/configuration";

// helpers
import {
  seoGetContentRelayOnConfiguration,
  seoGetContentRelayOnContent,
} from "@cloudspire/legacy-resources/src/helpers/seo";
import channelBuildHostFromConfiguration from "@cloudspire/shared/helpers/channel/buildHostFromConfiguration";

// constants
import { SEO_PAGE_VALUE_SEARCH } from "@cloudspire/legacy-resources/src/constants/seo";

function RoomListSEO(props) {
  const { useContent, content } = props;

  const route = useRoute();

  const { frontRouter } = useRouters();

  const configuration = useConfiguration();

  const seoInformation = [];

  if (useContent) {
    const coverUri = content?.coverUri;

    if (content) {
      seoInformation.push(
        ...seoGetContentRelayOnContent({
          configuration,
          content,
        })
      );
    }

    if (coverUri) {
      seoInformation.push(
        <meta key="ogImage" property="og:image" content={coverUri} />
      );

      seoInformation.push(
        <meta key="twitterImage" name="twitter:image" content={coverUri} />
      );
    }
  } else {
    seoInformation.push(
      ...seoGetContentRelayOnConfiguration({
        configuration,
        page: SEO_PAGE_VALUE_SEARCH,
      })
    );

    seoInformation.push(<meta key="robots" name="robots" content="noindex" />);

    seoInformation.push(
      <meta key="googlebot" name="googlebot" content="noindex" />
    );
  }

  return (
    <Head>
      <link
        key="canonical"
        rel="canonical"
        href={generateUri({
          router: frontRouter,
          name: route.getName(),
          parameters: route.getParameters(),
          query: {},
          scheme: "https",
          host: channelBuildHostFromConfiguration({
            channelConfiguration: configuration,
            websiteType: "front",
          }),
        })}
      />

      {seoInformation}
    </Head>
  );
}

export default RoomListSEO;
